export type AuthFormValues = {
  email?: string;
  password?: string;
  confirmPassword?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  code?: string;
};

export type ValidationErrors = {
  email?: string;
  password?: string;
  confirmPassword?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  code?: string;
};

export enum AuthModeEnum {
  LOGIN = "login",
  REGISTER = "register",
  FORGOT = "forgot",
  RESET = "reset",
  CODE = "code",
  EDIT_PROFILE = "edit-profile",
}

export type AuthMode = (typeof AuthModeEnum)[keyof typeof AuthModeEnum];

export enum ThemeTypeEnum {
  DARK = "dark",
  LIGHT = "light",
  DEFAULT = "default",
}

export type ThemeType = (typeof ThemeTypeEnum)[keyof typeof ThemeTypeEnum];
